import React from 'react';

import Commands from '../../Commands';

const Operations = ({ routes }) => <Commands routes={routes}/>;

export default Operations;
